import React from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { useTheme } from '../providers/ThemeProvider';
export const TermsOfServicePage = () => {
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  return <div className={`min-h-screen ${isDark ? 'bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50]' : 'bg-gradient-to-r from-gray-50 to-gray-100'}`} data-id="element-10342">
      <Navbar data-id="element-10343" />

      {/* Main Content */}
      <div className="pt-20 pb-16" data-id="element-10344">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-10345">
          <div className={`${isDark ? 'bg-navy-800' : 'bg-white'} rounded-xl shadow-lg p-8 md:p-12`} data-id="element-10346">
            <h1 className={`text-4xl font-bold mb-8 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10347">
              Terms of Service
            </h1>

            <div className={`prose prose-lg max-w-none ${isDark ? 'prose-invert' : ''}`} data-id="element-10348">
              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10349">
                <strong data-id="element-10350">Last Updated:</strong> January 15, 2025
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10351">
                Welcome to Maestro Connect ("Maestro Connect," "we," "us," or
                "our"), operated by Maestro Connect, Inc. These Terms of Service
                ("Terms") govern your access to and use of the Maestro Connect
                platform, including our website, applications, dashboards, and
                related services (collectively, the "Platform").
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10352">
                By accessing or using Maestro Connect, you agree to be bound by
                these Terms. If you do not agree, you may not use the Platform.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10353">
                1. Eligibility & Accounts
              </h2>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10354">
                1.1 Age Requirements
              </h3>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10355">
                <li data-id="element-10356">
                  Maestro Connect is intended for users 18 years of age or
                  older.
                </li>
                <li data-id="element-10357">
                  Parents or legal guardians may create and manage accounts on
                  behalf of minors.
                </li>
                <li data-id="element-10358">
                  By creating an account for a minor, the parent or guardian
                  represents that they have full legal authority to do so and
                  accepts responsibility for the minor's use of the Platform.
                </li>
              </ul>

              <h3 className={`text-xl font-semibold mt-6 mb-3 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10359">
                1.2 Account Responsibility
              </h3>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10360">
                <li data-id="element-10361">
                  You agree to provide accurate, complete, and current
                  information.
                </li>
                <li data-id="element-10362">
                  You are responsible for maintaining the confidentiality of
                  your login credentials.
                </li>
                <li data-id="element-10363">
                  You are fully responsible for all activity that occurs under
                  your account.
                </li>
              </ul>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10364">
                We reserve the right to suspend or terminate accounts that
                violate these Terms.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10365">
                2. Nature of the Platform
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-10366">
                Maestro Connect is a lesson organization, scheduling, and
                management platform designed to help teachers and students
                coordinate educational activities.
              </p>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-10367">
                Maestro Connect does NOT:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10368">
                <li data-id="element-10369">Guarantee lesson outcomes or educational results</li>
                <li data-id="element-10370">Provide instruction or teaching services</li>
                <li data-id="element-10371">Verify teacher qualifications</li>
                <li data-id="element-10372">Supervise or monitor live lessons</li>
              </ul>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10373">
                Live instruction and communication may occur via third-party
                services (such as Zoom, Google Meet, or similar tools). Maestro
                Connect is not responsible for those services.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10374">
                3. Teachers & Students
              </h2>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10375">
                <li data-id="element-10376">
                  Teachers are solely responsible for their lesson content,
                  conduct, scheduling, and interactions with students.
                </li>
                <li data-id="element-10377">
                  Students and parents are responsible for selecting teachers
                  and determining suitability.
                </li>
                <li data-id="element-10378">
                  Maestro Connect is not a party to any agreement between
                  teachers and students.
                </li>
              </ul>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10379">
                Any disputes between users must be resolved directly between
                those users.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10380">
                4. Payments & Subscriptions
              </h2>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10381">
                <li data-id="element-10382">
                  Payments are processed by third-party payment providers,
                  including Paddle.
                </li>
                <li data-id="element-10383">
                  Maestro Connect does not store credit card or banking
                  information.
                </li>
                <li data-id="element-10384">
                  Pricing, subscriptions, and features may change at any time.
                </li>
                <li data-id="element-10385">
                  All subscription payments are final unless otherwise stated.
                </li>
                <li data-id="element-10386">
                  Refunds may be issued at the sole discretion of Maestro
                  Connect in exceptional cases.
                </li>
              </ul>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10387">
                We are not responsible for payment processor errors, delays, or
                outages.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10388">
                5. Acceptable Use
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-10389">
                You agree not to:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10390">
                <li data-id="element-10391">Harass, abuse, threaten, or exploit others</li>
                <li data-id="element-10392">Upload unlawful, harmful, or inappropriate content</li>
                <li data-id="element-10393">Use the Platform for illegal or unauthorized purposes</li>
                <li data-id="element-10394">
                  Attempt to access systems, data, or accounts without
                  authorization
                </li>
                <li data-id="element-10395">Reverse engineer, scrape, or disrupt the Platform</li>
              </ul>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10396">
                Violation of these rules may result in suspension or permanent
                termination.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10397">
                6. User Content & Ownership
              </h2>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10398">
                <li data-id="element-10399">You retain ownership of content you create or upload.</li>
                <li data-id="element-10400">
                  By using the Platform, you grant Maestro Connect a limited,
                  non-exclusive, royalty-free license to host, store, display,
                  and process content solely to operate the Platform.
                </li>
                <li data-id="element-10401">
                  Maestro Connect is not responsible for user-generated content
                  and does not endorse any user content.
                </li>
              </ul>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10402">
                7. Platform Availability & Changes
              </h2>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10403">
                <li data-id="element-10404">The Platform is provided "as is" and "as available."</li>
                <li data-id="element-10405">
                  We do not guarantee uninterrupted service or error-free
                  operation.
                </li>
                <li data-id="element-10406">
                  Features may be added, modified, or removed at any time
                  without notice.
                </li>
              </ul>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10407">
                8. Limitation of Liability
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-10408">
                To the maximum extent permitted by law:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10409">
                <li data-id="element-10410">
                  Maestro Connect shall not be liable for indirect, incidental,
                  consequential, or special damages.
                </li>
                <li data-id="element-10411">
                  We are not liable for educational outcomes, personal disputes,
                  financial losses, or data loss.
                </li>
                <li data-id="element-10412">
                  Our total liability shall not exceed the amount paid by you to
                  Maestro Connect in the preceding 12 months.
                </li>
              </ul>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10413">
                9. Indemnification
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-10414">
                You agree to indemnify and hold harmless Maestro Connect, its
                officers, directors, employees, and affiliates from any claims,
                damages, losses, or expenses arising from:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10415">
                <li data-id="element-10416">Your use of the Platform</li>
                <li data-id="element-10417">Your violation of these Terms</li>
                <li data-id="element-10418">Your interactions with other users</li>
              </ul>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10419">
                10. Termination
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-10420">
                We may suspend or terminate your access:
              </p>

              <ul className={`list-disc pl-6 mb-6 ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10421">
                <li data-id="element-10422">For violation of these Terms</li>
                <li data-id="element-10423">For misuse of the Platform</li>
                <li data-id="element-10424">At our discretion, with or without notice</li>
              </ul>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10425">
                Upon termination, your right to use the Platform ends
                immediately.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10426">
                11. Governing Law
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10427">
                These Terms are governed by the laws of the State of Delaware,
                without regard to conflict-of-law principles.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10428">
                12. Changes to These Terms
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-6`} data-id="element-10429">
                We may update these Terms from time to time. Continued use of
                the Platform after changes constitutes acceptance of the updated
                Terms.
              </p>

              <h2 className={`text-2xl font-semibold mt-8 mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-10430">
                13. Contact Us
              </h2>

              <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'} mb-4`} data-id="element-10431">
                If you have questions about these Terms, contact us at:
              </p>

              <div className={`${isDark ? 'bg-navy-700' : 'bg-gray-50'} p-6 rounded-lg mb-6`} data-id="element-10432">
                <p className={`${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10433">
                  <strong data-id="element-10434">Email:</strong>{' '}
                  <a href="mailto:support@maestroconnect.com" className="text-deep-pink hover:underline" data-id="element-10435">
                    support@maestroconnect.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer data-id="element-10436" />
    </div>;
};